import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';

function PasswordChangedSuccess(props) {
    const { useCreatePasswordForm } = props.model;
    return (
        <AuthWrapper heading={`Password successfully ${useCreatePasswordForm ? 'set' : 'changed'}`}>
            {useCreatePasswordForm
                ? (
                    <section className="sten-content__section">
                        <p>Your password is successfully set.</p>
                        <p>You can start using the application now.</p>
                    </section>
                ) : (
                    <section className="sten-content__section">
                        <p>Your password is successfully changed.</p>
                        <p>You can go back to work now.</p>
                    </section>
                )}
            <section className="sten-content__section">
                <a
                    className="btn btn--primary btn--sm col-24"
                    href={`/Account/Login?returnUrl=${encodeURIComponent(props.model.returnUrl || '/')}`}
                >
                    {`${useCreatePasswordForm ? 'Go' : 'Back'} to login`}
                </a>
            </section>
        </AuthWrapper>
    );
}

PasswordChangedSuccess.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default PasswordChangedSuccess;
